import { render, staticRenderFns } from "./BasePlannerAssessor.vue?vue&type=template&id=86263ddc&"
import script from "./BasePlannerAssessor.vue?vue&type=script&lang=js&"
export * from "./BasePlannerAssessor.vue?vue&type=script&lang=js&"
import style0 from "./BasePlannerAssessor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports